<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Report</h1>
                    <div style="display: inline-block; float: right; margin-top: -40px;">
                        <el-button icon="el-icon-document" class="u-mr-small" type="success" @click="doExport()">Export</el-button>
                        <el-date-picker
                            v-model="daterange"
                            type="daterange"
                            format="dd MMM yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Start"
                            @change="changeDate"
                            :picker-options="datePickerOptions"
                            end-placeholder="End">
                        </el-date-picker>
                    </div>
                    <el-button size="small" icon="el-icon-back" @click="goBack()" v-if="params.region">Back</el-button>
                    <div class="custom_toolbar u-mt-medium">
                        <Select2 v-if="role_id==1" class="c-input" v-model="params.region" :options="regions" :settings="{ width: '100%', placeholder: 'All Region' }" @change="myChangeEvent($event)" @select="mySelectEvent($event)"/>
                        <Select2 v-if="role_id!=3" class="c-input" v-model="params.branch" :options="branches" :settings="{ width: '100%', placeholder: 'All Branch' }" @change="myChangeEvent2($event)"/>
                        <Select2 v-if="role_id!=3" class="c-input" v-model="params.outlet" :options="outlets" :settings="{ width: '100%', placeholder: 'All Outlet' }" @change="myChangeEvent3($event)"/>
                        <!-- <Select2 class="c-input" v-model="params.position" :options="positions" :settings="{ width: '100%', placeholder: 'All Type' }" @change="myChangeEvent4($event)"/> -->
                        <!-- <input type="text" placeholder="Search..." class="c-input" v-model="params.q" v-on:keyup="search"> -->
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-12">
                    <h4 v-if="rowsFacility.length > 0 && params.outlet">Employees</h4>
                    <vue-good-table v-loading="loading"
                        
                        :columns="columns"
                        :rows="rows"
                        
                        @on-page-change="onPageChange"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true,
                            setCurrentPage: page
                        }">
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'outlet'">
                                <el-row type="flex" justify="center">
                                    <el-col>
                                        <el-tag type="info" v-show="props.row.is_facility == 0" size="mini">{{JSON.parse(props.row.object).id}}</el-tag> {{JSON.parse(props.row.object).name}}<br/>
                                        <el-tag size="mini">{{props.row.outlet_name}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else-if="props.column.field == 'visitor'">
                                <el-row type="flex" justify="center">
                                    <el-col>
                                        {{props.row.visitor_name.toUpperCase()}}<br/>
                                        <el-tag size="mini" type="success">{{props.row.visitor_phone}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else-if="props.column.field == 'average'">
                                <el-rate
                                    :value="parseFloat(props.row.average)"
                                    disabled
                                    show-score
                                    text-color="#ff9900"
                                    score-template="{value} star">
                                </el-rate>
                            </span>
                            <span v-else-if="props.column.field == 'action'">
                                <el-button size="mini" icon="el-icon-view" @click="gotoDetail(props.row.originalIndex)">Detail</el-button>
                            </span>
                            <span v-else-if="props.column.field == 'name'">
                                {{props.row.name.toUpperCase()}}
                            </span>
                            <span v-else-if="props.column.field == 'positive'">
                                {{props.row.positive.toLocaleString('ID')}}
                            </span>
                            <span v-else-if="props.column.field == 'negative'">
                                {{props.row.negative.toLocaleString('ID')}}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>

            <div class="row u-mt-medium" v-if="rowsFacility.length > 0 && params.outlet">
                <div class="col-12">
                    <h4 v-if="rowsFacility.length > 0 && params.outlet">Facility</h4>
                    <vue-good-table v-loading="loading"
                        :columns="columnsFacility"
                        :rows="rowsFacility"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true
                        }">
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'outlet'">
                                <el-row type="flex" justify="center">
                                    <el-col>
                                        <el-tag type="info" v-show="props.row.is_facility == 0" size="mini">{{JSON.parse(props.row.object).id}}</el-tag> {{JSON.parse(props.row.object).name}}<br/>
                                        <el-tag size="mini">{{props.row.outlet_name}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else-if="props.column.field == 'visitor'">
                                <el-row type="flex" justify="center">
                                    <el-col>
                                        {{props.row.visitor_name.toUpperCase()}}<br/>
                                        <el-tag size="mini" type="success">{{props.row.visitor_phone}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else-if="props.column.field == 'average'">
                                <el-rate
                                    :value="parseFloat(props.row.average)"
                                    disabled
                                    show-score
                                    text-color="#ff9900"
                                    score-template="{value} star">
                                </el-rate>
                            </span>
                            <span v-else-if="props.column.field == 'positive'">
                                {{props.row.positive.toLocaleString('ID')}}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import api from '@/api/ratings'
    import regions from '@/api/regions'
    import branches from '@/api/branches'
    import outlets from '@/api/outlets'
    import Select2 from 'v-select2-component';
    import { mapActions } from 'vuex';
    import moment from 'moment'
    import axios from 'axios'

    export default {
        components: {
            'vue-good-table':VueGoodTable,
            Select2
        },
        data() {
            return {
                role_id: localStorage.getItem('user_role_id'),
                relation_code: localStorage.getItem('relation_code'),
                relation_name: localStorage.getItem('relation_name'),
                columns: [
                    {
                        label: 'Code',
                        field: 'code'
                    },
                    {
                        label: 'Name',
                        field: 'name'
                    },
                    // {
                    //     label: 'Nilai Rata-rata',
                    //     field: 'average'
                    // },
                    {
                        label: 'Jumlah Nilai Positif',
                        field: 'positive',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                    },
                    {
                        label: 'Jumlah Nilai Negatif',
                        field: 'negative',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                    }
                ],
                rows: [],
                columnsFacility: [
                    {
                        label: 'Name',
                        field: 'name'
                    },
                    // {
                    //     label: 'Nilai Rata-rata',
                    //     field: 'average'
                    // },
                    {
                        label: 'Jumlah Nilai Positif',
                        field: 'positive',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                    },
                    {
                        label: 'Jumlah Nilai Negatif',
                        field: 'negative',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                    }
                ],
                rowsFacility: [],

                totalRecords: 0,
                page: 1,
                regions: [],
                branches: [],
                outlets: [],
                params: {
                    q: '',
                    position: '',
                    region: localStorage.getItem('user_role_id') == 2 ? localStorage.getItem('relation_code') : '',
                    outlet: localStorage.getItem('user_role_id') == 3 ? localStorage.getItem('relation_code') : '',
                    branch: '',
                    facility: ''
                },
                loading: false,
                errorMessage: null,
                datePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                daterange: [],
            }
        },
        created () {
            let end = this.$route.query.end ? this.$route.query.end : new Date()
            var start = this.$route.query.start ? this.$route.query.start : moment(start).subtract(1, 'months')._d;

            // end = new Date(end)
            this.daterange = [start, end]


            this.params.region = this.$route.query.region ? this.$route.query.region : ''
            this.params.outlet = this.$route.query.outlet ? this.$route.query.outlet : ''
            this.params.branch = this.$route.query.branch ? this.$route.query.branch : ''

            if(this.params.region) {
                this.fetchBranches()
            }
            if(this.params.region) {
                this.fetchOutlets()
            }
            
            this.fetch();
            if(this.role_id==1){
                this.fetchRegions();
            }
            if(this.role_id==2){
                this.fetchBranches();
            }
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            dateField(rowObj) {
                return moment(rowObj.created_at).format('dddd, DD MMMM YYYY / H:mm')
            },
            changeDate() {
                this.$router.replace({
                    query: { 
                        start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                        end: moment(this.daterange[1]).format('YYYY-MM-DD')
                    }
                })
                this.fetch()
            },
            fetch() {
                this.loading = true
                var self = this
                axios.get('https://api-dash.bniservicerating.com/v1/rating/report?startdate='+moment(this.daterange[0]).format('YYYY-MM-DD')+'&enddate='+moment(this.daterange[1]).format('YYYY-MM-DD')+'&outlet_code='+this.params.outlet+'&branch_code='+this.params.branch+'&region_code='+this.params.region, {
                    headers: {
                        'x-api-key': 'DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt',
                        'x-access-token': localStorage.getItem('accessToken')
                    }
                })
                // api.getRegion(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), '')
                .then(function (response) {
                    if(response.data.data.length > 0){
                        self.rows = response.data.data
                        // self.totalRecords = 100
                        self.loading = false
                    } else {
                        self.loading = false
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchFacility() {
                this.loading = true
                var self = this
                api.getRegion(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), 1)
                .then(function (response) {
                    if(response.data.data.length > 0){
                        self.rowsFacility = response.data.data
                        // self.totalRecords = 100
                        self.loading = false
                    } else {
                        self.loading = false
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            onPageChange(params) {
                // console.log(params)
                this.page = params.currentPage
                this.fetch();
            },
            fetchRegions() {
                this.loading = true
                var self = this
                regions.getAll()
                .then(function (response) {
                    // 
                    var regionsx = [{
                        id: 999999,
                        text: 'All Region'
                    }];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.regions = regionsx
                    self.loading = false
                    // console.log(self.regions)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchBranches() {
                var self = this
                branches.getAll(this.params.region)
                .then(function (response) {
                    // 
                    var regionsx = [{
                        id: 999999,
                        text: 'All Branches'
                    }];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.branches = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchOutlets() {
                var self = this
                outlets.getAll(this.params.region, this.params.branch)
                .then(function (response) {
                    // 
                    var regionsx = [{
                        id: 999999,
                        text: 'All Outlets'
                    }];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.outlets = regionsx
                    // console.log(self.outlets)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            myChangeEvent(val){
                // console.log(val);
                this.params.region = val
                this.params.branch = ''
                this.$router.replace({
                    query: { region: val }
                })
                this.fetchBranches()
                this.fetch();
                this.rowsFacility = []
            },
            mySelectEvent({id, text}){
                // console.log({id, text})
            },
            myChangeEvent2(val){
                // console.log(val);
                this.params.branch = val
                this.params.outlet = ''
                this.$router.replace({
                    query: { region: this.params.region, branch: val, start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                        end: moment(this.daterange[1]).format('YYYY-MM-DD') }
                })
                this.fetchOutlets();
                this.fetch();
                this.rowsFacility = []
            },
            myChangeEvent3(val){
                // console.log(val);
                this.params.outlet = val
                this.$router.replace({
                    query: { region: this.params.region, branch: this.params.branch, outlet: val, start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                        end: moment(this.daterange[1]).format('YYYY-MM-DD') }
                })
                this.fetch();
                this.fetchFacility();
            },
            myChangeEvent4(val){
                // console.log(val);
                this.params.position = val
                this.$router.replace({
                    query: { region: this.params.region, branch: this.params.branch, outlet: this.params.outlet, position: val, start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                        end: moment(this.daterange[1]).format('YYYY-MM-DD') }
                })
                this.fetch();
            },
            search() {
                this.fetch();
            },
            switchChanged(npp) {
                // console.log('switchChanged')
                // console.log(npp)
                var self = this
                api.setAttend(npp)
                .then(function (response) {
                    self.fetch()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            gotoDetail(idx) {
                this.page = 1
                // console.log(idx)
                if(this.$route.query.region)  {
                    if(this.$route.query.branch)  {
                        if(this.$route.query.outlet)  {
                            // window.open('/report/detail/'+ this.rows[idx].code, '_blank');
                            this.$router.push({name: 'reportdetail', params: {
                                code: this.rows[idx].code,
                                name: this.rows[idx].name,
                            }, query: {
                                start: moment(this.daterange[0]).format('YYYY-MM-DD'), 
                                end: moment(this.daterange[1]).format('YYYY-MM-DD')
                            } })
                        } else {
                            this.params.outlet = this.rows[idx].code
                            this.$router.replace({
                                query: { region: this.params.region, branch:  this.params.branch, outlet: this.params.outlet, start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                                        end: moment(this.daterange[1]).format('YYYY-MM-DD')}
                            })
                            this.fetch()
                            this.fetchFacility()
                        }
                    } else {
                        this.params.branch = this.rows[idx].code
                        this.$router.replace({
                            query: { region: this.params.region, branch:  this.params.branch, start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                                    end: moment(this.daterange[1]).format('YYYY-MM-DD')}
                        })
                        this.fetchOutlets()
                        this.fetch()
                    }
                } else {
                    this.params.region = this.rows[idx].code
                    this.$router.replace({
                        query: { region: this.params.region , start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                                end: moment(this.daterange[1]).format('YYYY-MM-DD')}
                    })
                    this.fetchBranches();
                    this.fetch()
                }
            },
            goBack() {
                if(this.params.outlet){
                    this.$router.replace({
                        query: { 
                            region: this.params.region, 
                            branch:  this.params.branch,
                            start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                            end: moment(this.daterange[1]).format('YYYY-MM-DD')
                        }
                    })
                    this.params.outlet = ''
                    this.fetch()
                } else {
                    if(this.params.branch){
                        this.$router.replace({
                            query: { 
                                region: this.params.region,
                                start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                                end: moment(this.daterange[1]).format('YYYY-MM-DD')
                            }
                        })
                        this.params.branch = ''
                        this.fetch()
                    } else {
                        if(this.params.region){
                            this.$router.replace({
                                query: { 
                                    region: '',
                                    start: moment(this.daterange[0]).format('YYYY-MM-DD'),
                                    end: moment(this.daterange[1]).format('YYYY-MM-DD')
                                }
                            })
                            this.params.region = ''
                            this.fetch()
                        }
                    }
                }
            }  ,
            doExport(){
                this.loading = true
                var self = this
                axios.get('https://api-dash.bniservicerating.com/v1/rating/export-excel?startdate='+moment(this.daterange[0]).format('YYYY-MM-DD')+'&enddate='+moment(this.daterange[1]).format('YYYY-MM-DD')+'&outlet_code='+this.params.outlet+'&branch_code='+this.params.branch+'&region_code='+this.params.region, {
                    headers: {
                        'x-api-key': 'DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt',
                        'x-access-token': localStorage.getItem('accessToken'),
                        'Content-Disposition': "attachment; filename=template.xlsx",
                        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    },
                    responseType: 'arraybuffer'
                })
                // api.getRegion(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), '')
                .then(function (response) {
                    if(response.data){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'report.xlsx');
                        document.body.appendChild(link);
                        link.click();

                        self.loading = false
                    } else {
                        self.loading = false
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
.custom_toolbar {
    display: flex;
    div {
        margin-right: 10px;
    }
}
.el-row--flex.is-justify-center {
    align-items: center !important;
}
</style>